<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import comparator
</style>

<script>

    import { get, indexOf, orderBy, without } from 'lodash'

    import JSON_FILTERS from './json/filters.json'
    import JSON_FILTERS_SAMPLE from './json/filters-sample.json'
    import JSON_BENCH_SAMPLE from './json/bench-sample.json'
    import JSON_MAP from './json/map.json'
    import JSON_OFFERS from './json/offers.json'

    import PageComparatorCard from '../../pages/node-comparator/PageComparatorCard.vue'
    import PageComparatorFilters from '../../pages/node-comparator/PageComparatorFilters.vue'
    import PageComparatorPopin from '../../pages/node-comparator/PageComparatorPopin.vue'
    import PageComparatorSelect from '../../pages/node-comparator/PageComparatorSelect.vue'
    import PageComparatorTable from '../../pages/node-comparator/PageComparatorTable.vue'

    export default {
        jsonMap: JSON_MAP,
        jsonFilters: JSON_FILTERS.filters,
        jsonOffers: JSON_OFFERS,
        name: 'page-comparator',
        components: {
            PageComparatorCard,
            PageComparatorFilters,
            PageComparatorPopin,
            PageComparatorSelect,
            PageComparatorTable
        },
        props: {
            dataProps: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                results: {
                    recommended: [],
                    selected: []
                },
                filters: this.$options.jsonFilters,
                // filters: JSON_FILTERS_SAMPLE.filters,
                step: 1,
                // step: 5,
                bench: [],
                // bench: JSON_BENCH_SAMPLE.results,
                popin: {},
                benchLimit: 5,
                displayComparator: false,
                displayPopin: false,
                displayFiltersPanel: false
            }
        },
        computed: {
            filtersCount () {
                return Object.keys(this.filters).length
            },
            displayResult () {
                return this.step > this.filtersCount
            },
            urls () {
                return JSON.parse(this.dataProps)
            },
            isBenchmarkReady () {
                return this.bench.length > 1
            },
            isBenchmarkFull () {
                return this.bench.length >= this.benchLimit
            }
        },
        watch: {
            filters: {
                handler: 'getResults',
                immediate: true
            },
            displayResult (val) {
                if (val === true) {
                    this.scrollToTop()
                }
            },
            displayComparator (val) {
                this.scrollToTop()
            }
        },
        methods: {
            goToStep (step) {
                if (step < this.step) {
                    this.step = step
                }
            },
            getFilter () {
                return this.filters[this.step - 1]
            },
            getResults () {
                const ids = this.filters.map(filter => filter.selection)
                const results = (get(this.$options.jsonMap, ids) || {}).results

                this.results = {
                    selected: results ? this.populateResult(results.selected) : [],
                    recommended: results ? this.populateResult(results.recommended) : []
                }
            },
            isResultSelected( result ) {
                return this.bench.some(b => b === result)
            },
            populateResult (ids) {
                const offers = ids ? ids.map(id => this.$options.jsonOffers[id]) : []
                return orderBy(
                    offers,
                    ['type', 'variation', 'features.tank.capacity', 'features.delivery', 'price.duration', 'price.unit'] ,
                    ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']
                )
            },
            updateBench (result) {
                const index = indexOf(this.bench, result)

                if (index !== -1) {
                    this.bench = without(this.bench, result)
                } else {
                    this.bench = !this.isBenchmarkFull ? [...this.bench, result ] :  this.bench
                }
            },
            updateFilter (ref, answer) {
                this.filters = this.filters.map(f => {
                    return (f === ref)
                        ? { ...f, selection: answer.id }
                        : f
                })
                if (!this.displayResult) {
                    this.step++
                }
                this.bench = []
            },
            toggleFilters () {
                this.displayFiltersPanel = !this.displayFiltersPanel
                /*if(window.innerWidth < 768) {
                    document.body.parentNode.style.overflow = this.displayFiltersPanel ? 'hidden' : ''
                    document.body.style.overflow = this.displayFiltersPanel ? 'hidden' : ''
                }*/
            },
            togglePopin( result = {} ) {
                this.popin = result
                this.displayPopin = !this.displayPopin
            },
            toggleComparator(state) {
                this.displayComparator = state
            },
            scrollToTop() {
                window.scrollTo({top: 0,  behavior: "smooth"})
            }
        }
    }
</script>

<script setup>

</script>
